import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=2614183c&scoped=true&"
import script from "./LabelSelector.vue?vue&type=script&lang=js&"
export * from "./LabelSelector.vue?vue&type=script&lang=js&"
import style0 from "./LabelSelector.vue?vue&type=style&index=0&id=2614183c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2614183c",
  null
  
)

export default component.exports